import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ROUTES } from '@/routes/paths';

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('notFound.title')}
      extra={
        <Link to={ROUTES.ROUTES}>
          <Button type="primary">{t('notFound.backHome')}</Button>
        </Link>
      }
    />
  );
}
